module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAAXNSR0IArs4c6QAAAQBJREFUSEtjnBcj+5+BDoARZFHkrBs0tWp5mgbDCLDoxPwKhq9vn2INSvOEdgYeERm4HLFqsQbdtnpvho/P72K1yKthMwO/lCpcjli1OC368fk9Q1DfMbISyJmljQy3Dy5nQHbUqEVEBeXgC7q39y8x/Pv7h0FUxYgoH6Ar+vTyAcP3Dy8ZhBV0GVjYucDSI6RkICu8CGjCGnSgYuXX988MdllTybLzxp4FDE8v7GVALq5GMyxRQTn4Miyo6P/y9hmDpnsyhg9UHSIZOHiF4eK39y9l+PHlPYq6Z5cOMLx7eIW40psu9RGoCPrz6zvW+EAuVkAKiFU7jIsgotIthYoAUK1EZoRGUrUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/full-screen.png
// module id = OFu9
// module chunks = 1